const colors = {
  $dark: '#161829',
  $G6: '#5e6480',
  $G8: '#25293b',
  $B5: '#41a5f5',
  $T6: '#009688',
  $DP5: '#7e57c2',
  $L8: '#afb42c',
};

export default colors;
